import { useState, useEffect } from 'react';
import * as C from './styles';
import { iso } from '../../../../../../components/iso';
import Load from '../../../../../../components/load';

export default function Images({ media_type, movie_id }) {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imagesType, setImagesType] = useState('backdrops');
  const [imagesLengthVisible, setImagesLengthVisible] = useState(12);
  const [language, setLanguage] = useState('pt');

  useEffect(() => {
    fetch(`https://api.themoviedb.org/3/${media_type}/${movie_id}/images?api_key=${process.env.REACT_APP_TMDB_KEY}`)
      .then(response => response.json())
      .then(data => {
        setImages(data);
        setTimeout(() => setLoading(false), 500);
      });
  }, [media_type, movie_id]);

  useEffect(() => {
    setImagesLengthVisible(12);
  }, [imagesType, media_type, movie_id, language]);

  const changeImageType = (type) => {
    setImagesType(type);
    setLoading(true);
    setTimeout(() => setLoading(false), 300);
  };

  const loadMore = () => {
    const remainingMovies = images[imagesType].length - imagesLengthVisible;
    const nextBatch = Math.min(remainingMovies, 12);
    setImagesLengthVisible(prev => prev + nextBatch);
  };

  const handleImageTypeChange = (e) => {
    const newType = e.target.value;
    setImagesType(newType);
  
    // Se o tipo de imagem for "logos" e o idioma for "none", redefina o idioma para o padrão ("pt")
    if (newType === 'logos' && language === 'none') {
      setLanguage('pt');
    }
  
    setLoading(true);
    setTimeout(() => setLoading(false), 300);
  };

  const handleLanguageChange = (e) => {
    setLanguage(e.target.value);
  };

  return (
    <C.Container>
      <header>
        <C.SelectContainer>
          <label htmlFor="image-type-select">Tipo:</label>
          <select id="image-type-select" value={imagesType} onChange={handleImageTypeChange}>
            <option value="backdrops">Imagens de fundo</option>
            <option value="logos">Logos</option>
            <option value="posters">Pôsteres</option>
          </select>
        </C.SelectContainer>

        <C.SelectContainer>
          <label htmlFor="language-select">Idioma:</label>
          <select id="language-select" value={language} onChange={handleLanguageChange}>
            <option value="pt">Português</option>
            <option value="en">Inglês</option>
            <option value="all">Qualquer idioma</option>
            {imagesType !== 'logos' && <option value="none">Sem idioma</option>}
          </select>
        </C.SelectContainer>
      </header>

      {loading ? (
        <Load align_center={true}/>
      ) : (
        <C.Content imagesType={imagesType}>
          {images && images[imagesType]?.length >= 1 ? (
            images[imagesType]
              ?.filter(image => 
                language === 'all' || 
                language === 'none' && image.iso_639_1 === null || 
                image.iso_639_1 === language
              )
              .slice(0, imagesLengthVisible)
              .map((image, key) => (
                <div key={key} className="div-image">
                  <C.Image
                    imagesType={imagesType}
                    loading="lazy"
                    src={`https://image.tmdb.org/t/p/w400${image.file_path}`}
                    alt={`Image ${key}`}
                  />
                  {language === 'all' && image.iso_639_1 && (
                    <span className="language"><i className="fa-solid fa-earth-americas"></i> {iso[image.iso_639_1]}</span>
                  )}
                </div>
              ))
          ) : (
            <span>Não há imagens!</span>
          )}
        </C.Content>
      )}

      {!loading && (images[imagesType]?.filter(image => language === 'all' || language === 'none' && image.iso_639_1 === null || image.iso_639_1 === language)?.length == 0) &&
        <div className='container-no-image'>
          <span className='no-image'>Sem imagens!</span>
        </div>
      }

      {( !loading && (images[imagesType]?.filter(image => language === 'all' || language === 'none' && image.iso_639_1 === null || image.iso_639_1 === language)?.length > imagesLengthVisible)) && (
        <section className='section-bt-more'>
          <button className='bt-more' onClick={loadMore}>Ver Mais</button>
        </section>
      )}
    </C.Container>
  );
}
